import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import { useReservationLedgerList } from '@/features/dashboard/reservationLedger/hooks/useReservationLedgerList';
import { ReservationLedgerTable } from '@/features/dashboard/reservationLedger/table';
import { Translation } from '@/hoslog-intl';
import { BarChart } from '@/icons';
import { ReservationLedger } from '@/services/dashboard/reservationLedger/reservationLedger.types';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const sortItemSchema = z.object({
  id: z.enum([
    'nickName',
    'invoiceNumber',
    'storeInfo',
    'createdDate',
    'reservationType',
    'visitingDateTime',
    'endingDateTime',
    'planType',
    'planName',
    'numberOfPeople',
    'clubVerificationStatus',
    'paymentType',
    'paymentMethod',
    'paymentStatus',
    'totalPlanAmount',
    'totalPlanCommissionAmount',
    'totalClubAmount',
    'totalAdminCommissionAmount',
    'totalAdminAmount',
  ]),
  desc: z.boolean(),
});

const reservationLedgerSearchSchema = z.object({
  sort: z
    .preprocess((val) => {
      if (typeof val === 'string') {
        try {
          return JSON.parse(val);
        } catch {
          return undefined;
        }
      }
      return val;
    }, z.array(sortItemSchema))
    .optional(),

  createdDate: z.string().optional(),

  q: z
    .any()
    .transform((val) => (val == null ? undefined : String(val)))
    .optional(),
  clubStatusFilter: z.enum(['A', 'C', 'P']).optional(),
  planTypeFilter: z.string().optional(),
  clubId: z.string().optional(),

  status: z
    .string()
    .transform((val) => val.split(','))
    .pipe(z.array(z.enum(['ACTIVE', 'INACTIVE'])))
    .optional(),

  page: z.coerce.number().positive().catch(0),
  fetch: z.coerce.number().positive().max(100).catch(10),
});

export const Route = createFileRoute('/(app)/dashboard/reservation-ledger/')({
  loader: () => {
    return {
      crumb: <CrumbTitle id="dashboard.crumb.reservationLedger" icon={BarChart} />,
      title: <Translation id="dashboard.crumb.reservationLedger" />,
    };
  },
  component: RouteComponent,
  validateSearch: (search: ReservationLedger) => reservationLedgerSearchSchema.parse(search),
});

function RouteComponent() {
  const { reservationLedger, isLoading, pagination } = useReservationLedgerList();
  return <ReservationLedgerTable data={reservationLedger} isLoading={isLoading} pagination={pagination} />;
}
